import Node from './Node';
import BinaryNode from './BinaryNode';
import TextType from './TextType';

export default class PhysicalQuantityNode extends BinaryNode {

	public toText (textType = TextType.PLAIN) {
		if (textType === TextType.PLAIN) {
			return super.toText();
		}

		return this.getLeft().toText(TextType.LATEX) + '\\,\\pu{' + this.getRight().toText(TextType.LATEX_PHYSICAL_UNIT) + '}';
	}

	protected create (left: Node, right: Node) {
		return new PhysicalQuantityNode(left, right);
	}

	protected getTextPrefix (textType?: TextType): string {
		return '';
	}

	protected getTextInfix (textType = TextType.PLAIN) {
		return ' ';
	}

	protected getTextPostfix (textType?: TextType): string {
		return '';
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/PhysicalQuantityNode.ts